import { WidgetType } from '@/models/Enums';

export default class MountPoints {
  public right: WidgetType[];
  public center: WidgetType[];

  constructor() {
    this.right = [];
    this.center = [];
  }
}